import React from 'react';

import {
  Form,
  Input,
  FormGroup,
  Label,
  Col,
  Button,
  Row,
  Container
} from 'reactstrap';
import { MdSearch, MdClear } from 'react-icons/lib/md';



const PesquisaProcessosForm = ({ buscarProcesso, fases, situacoes, responsaveis, alegacoes, exibirMensagem, fecharMensagem, mensagem, limparPesquisa, quandoMudar, carregaAlegacoesFase }) => {

  const pesquisar = evento => {
    evento.preventDefault();
    const form = evento.target;

    buscarProcesso(form.fase.value, form.processo.value, form.sei.value, form.situacao.value, form.responsavel.value, form.alegacoes.value);
    fecharMensagem();
  }

  const quandoMudarFase = evento => {
    evento.preventDefault();
    evento.target.value && carregaAlegacoesFase(evento.target.value);
  }

  return (
    <Form onSubmit={pesquisar}>
      <Container>
        <Row>
          <Col sm={4}>
            <FormGroup>
              <Label for="fase" className="lbl-required">Fase</Label>
              <Input type="select" required="required" name="fase" onChange={quandoMudarFase} >
                <option key="" />
                {
                  fases.map((fases) => (
                    <option key={fases.id} value={fases.id}>{fases.nome} </option>
                  ))
                }
              </Input>
            </FormGroup>
          </Col>

          <Col sm={4}>
            <FormGroup>
              <Label for="processo">Número do Processo</Label>
              <Input name="processo" maxLength={30} type="search" placeholder="ex: 000" />
            </FormGroup>
          </Col>

          <Col sm={4}>
            <FormGroup>
              <Label for="sei">Número SEI</Label>
              <Input readOnly name="sei" type="search" placeholder="ex: 00000000" />
            </FormGroup>
          </Col>


          <Col sm={4} lx={4}>
            <FormGroup>
              <Label for="situacao">Situação</Label>
              <Input type="select" name="situacao"  >
                <option key="" value="" />
                {
                  situacoes.map((descricao) => (
                    <option key={descricao.descricao} value={descricao.descricao}>{descricao.descricao} </option>
                  ))
                }

              </Input>
            </FormGroup>    
          </Col>

          <Col sm={4} lx={4}>
            <FormGroup>
              <Label for="responsavel">Responsável</Label>
              <Input type="select" name="responsavel" >
                <option key="" value="" />
                {
                  responsaveis.map((responsavel) => (
                    <option key={responsavel.id} value={responsavel.id}>{responsavel.nome} </option>
                  ))
                }
              </Input>
            </FormGroup>
          </Col>

          <Col sm={4} lx={4}>
            <FormGroup>
              <Label for="alegacoes">Alegações</Label>
              <Input type="select" name="alegacoes" >
                <option key="" value="" />
                {
                  alegacoes.map((alegacoes) => (
                    <option key={alegacoes.id} value={alegacoes.id}>{alegacoes.nome} </option>
                  ))
                }
              </Input>
            </FormGroup>
          </Col>
        </Row>    
      </Container>

      <Row>
        <Col sm={{ size: 4, offset: 8 }} className="col-button text-right">
          <Button type="submit" color="warning"><MdSearch size="30" />Pesquisar</Button>
          {'    '}
          <Button type="reset" color="secondary" onClick={limparPesquisa}><MdClear size="30" />Limpar</Button>
        </Col>
      </Row>

    </Form>
  );
};

export default PesquisaProcessosForm;



// WEBPACK FOOTER //
// ./src/componentes/PesquisaProcessosForm.js